import React from 'react';

export const UserContext = React.createContext(null);
export const withUser = Component => props => (
  <UserContext.Consumer>
    {userObj => <Component {...props} user={userObj} />}
  </UserContext.Consumer>
);
